// extracted by mini-css-extract-plugin
export default {"root":"addButton_root__6Jkno","btn":"addButton_btn__AnKLG"};